<template>
  <div class="md-layout upload-group">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon">
          <h3>{{ $t("seller.upload.excel.title") }}</h3>
        </md-card-header>
        <md-card-content>
          <div class="flex flex_column flex_between">
            <div class="card_content_head">
              <div class="xml_excel_upload">
                <h4 class="text_center">{{$t('seller.upload.excel.step1.title')}}</h4>
                <FileInputUpload v-on:upSuccess="upSuccess"></FileInputUpload>
                <div class="icon_tip">
                  <div>{{$t('seller.upload.excel.templates.tip')}}</div>
                    <a :href="xmlUrl" target="_blank" class="link_a">{{$t('seller.upload.excel.templates.downloadXml')}}</a>
                    <br />
                    <a class="link_a" :href="excelUrl" target="_blank">{{$t('seller.upload.excel.templates.downloadExcel')}}</a>
                  </div>
                </div>
            </div>
            <h3 v-if="videoUploadPercent == 0" class="inactive_color"></h3>
            <h3 class="accent_color" v-if="videoUploadPercent > 0">
              {{ $t("seller.upload.cardlist.Uploading") }}
              {{ videoUploadPercent + "%" }}
              {{ $t("seller.upload.cardlist.Documents") }}
            </h3>
          <h4 class="text_center font_bold" >{{$t('seller.upload.excel.step2.title')}}</h4>
              <div style="margin:1rem" @click="changeItem(item)">
              <FileUpload
                v-on:chageFile="chageFile"
                :filUrl="form.url"
                v-on:changePercent="changePercent"
                :disable="isLoading"
                :iconName="iconName"
                :accept="accept"
                :loadApi="'uploadDocuments'"
              ></FileUpload>
              </div>
            <p class="paf_tip text_center">{{ $t("seller.upload.excel.files.tip") }}</p>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import FileUpload from "src/components/templates/FileUpload.vue";
import FileInputUpload from "./FileInputUpload.vue";
import enumStatus from "src/common/enum";
import APP from "src/common/appConfig";
import {localization} from "src/common/lang/localization";

export default {
  components: {
    FileUpload,
    FileInputUpload
  },
  data() {
    return {
      form: { url: "" },
      upTypeList: [],
      activeItem: {},
      videoUploadPercent: 0,
      isLoading: false,
      accept: "pdf",
      iconName: "fa-file-text",
      xmlUrl: `${APP.DOMAIN}static/xml/Walbing-import-4.0-20220901.xml`,
      excelUrl: `${APP.DOMAIN}static/xls/Walbing-import-${localization.currentLocale()}-4.0-20220901.xlsx`,
      isUpload: false
    };
  },
  mounted() {
    this.upTypeList = enumStatus.upTypeList;
  },
  methods: {
    upSuccess(data) {
      this.isUpload = true;
    },
    chageFile(data) {},

    changePercent(data) {
      this.isLoading = true;
      this.videoUploadPercent = data;
      if (data >= 100) {
        setTimeout(() => {
          this.$emit("uploaded");
          this.videoUploadPercent = 0;
          this.isLoading = false;
        }, 500);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  @import "./upload.scss";
</style>
